import { useEffect } from 'react';
import { GlobalCSSVariable, useThemeContext } from '../../../../context/theme';
import '../main-navigation/main-nav.css';

import { useLocalStorage } from '@/hooks/browser/use-local-storage';

import { SideNav, PlumaProvider, useSideNavState } from '@customerio/pluma-components/react';
import { defaultTheme, newTheme, darkTheme } from '@customerio/pluma-components/css';
import { PlumaSideNav as PlumaSideNavCss } from '@customerio/pluma-components/css/components';
import { FeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';

import * as styles from './index.css';

export const NAV_COLLAPSED_LOCAL_STORAGE_KEY = 'hydra:is-main-nav-collapsed';

const NAV_WIDTHS = {
  collapsed: Number.parseInt(PlumaSideNavCss.values.collapsedWidth),
  expanded: Number.parseInt(PlumaSideNavCss.values.expandedWidth),
};

export function MainNavigationWrapper(props: { isCollapsible?: boolean; children?: React.ReactNode }) {
  const { isCollapsible = true, children } = props;

  const themeContext = useThemeContext();
  const sideNavState = useSideNavState();

  // setup guide nav setup
  const [, setIsNavCollapsed] = useLocalStorage<boolean>(NAV_COLLAPSED_LOCAL_STORAGE_KEY, false);

  useEffect(() => {
    if (sideNavState != null) {
      setIsNavCollapsed(sideNavState.isCollapsed);
    }
  }, [setIsNavCollapsed, sideNavState]);

  useEffect(() => {
    const navWidth = sideNavState?.isCollapsed === true ? NAV_WIDTHS.collapsed : NAV_WIDTHS.expanded;
    themeContext.setVariable(GlobalCSSVariable.MainNavWidth, `${navWidth}px`);
  }, [sideNavState?.isCollapsed, themeContext]);

  const withNewTokens = useFeatureFlag(FeatureFlag.NavTokens2026);

  const resolvedTheme = themeContext.isDarkMode ? darkTheme : withNewTokens ? newTheme : defaultTheme;

  return (
    <PlumaProvider theme={resolvedTheme} className={styles.sideNavContainer}>
      <SideNav
        isCollapsible={isCollapsible}
        isCollapsed={!isCollapsible ? false : undefined}
        overflowY="auto"
        overflowX="hidden"
        style={{ scrollbarWidth: 'thin' }}
      >
        {children}
      </SideNav>
    </PlumaProvider>
  );
}
